import { render, staticRenderFns } from "./CustomMethod.vue?vue&type=template&id=843dfac4&scoped=true"
import script from "./CustomMethod.vue?vue&type=script&lang=js"
export * from "./CustomMethod.vue?vue&type=script&lang=js"
import style0 from "./CustomMethod.vue?vue&type=style&index=0&id=843dfac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843dfac4",
  null
  
)

export default component.exports